// Стили для карточки
export const cardSx = {
    borderRadius: '16px',
    boxShadow: '0 0 16px 0 rgba(0, 0, 0, 0.10)',
    mb: 1,
    overflow: 'visible'
};
// Стили для поля времени
export const timeFieldSx = {
    width: 90,
    '& .MuiOutlinedInput-root': {
        borderRadius: '8px',
        height: 40,
        '& input': {
            padding: '8px 8px',
            textAlign: 'center',
            fontSize: '16px'
        }
    }
};
// Стили для кнопки удаления интервала
export const deleteButtonSx = {
    width: 40,
    height: 40,
    borderRadius: '8px',
    backgroundColor: 'rgba(228, 119, 119, 0.15)',
    '&:hover': {
        backgroundColor: 'rgba(228, 119, 119, 0.25)'
    }
};
// Стили для кнопки добавления интервала
export const addButtonSx = {
    width: 40,
    height: 40,
    borderRadius: '8px',
    border: '1px solid',
    borderColor: 'primary.main',
    '&:hover': {
        backgroundColor: 'action.hover'
    }
};
// Стили для большого переключателя (60x32px как в дизайне)
export const switchSx = {
    width: 60,
    height: 32,
    padding: 0,
    overflow: 'visible',
    '& .MuiSwitch-switchBase': {
        padding: 0,
        margin: '3px',
        '&.Mui-checked': {
            transform: 'translateX(28px)',
            color: '#fff',
            '& + .MuiSwitch-track': {
                backgroundColor: '#77E48A',
                opacity: 1,
            },
        },
    },
    '& .MuiSwitch-thumb': {
        width: 26,
        height: 26,
        boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
    },
    '& .MuiSwitch-track': {
        width: '100%',
        height: '100%',
        borderRadius: 16,
        backgroundColor: 'rgba(5, 4, 71, 0.2)',
        opacity: 1,
    },
};
// Стили для разделителя между полями времени
export const timeDividerSx = {
    width: 12,
    height: 2,
    backgroundColor: 'rgba(5, 4, 71, 0.3)',
    borderRadius: 1,
    flexShrink: 0
};
